import React from 'react';

import Avatar from 'components/Avatar';
import Dropzone from 'components/Dropzone';
import UppercaseText from 'components/UppercaseText';
import {ACCEPTED_IMAGE_FILE_TYPES} from 'ducks/files';

import wrongFormatImage from 'assets/icons/reject.svg';

import './styles.css';

interface AvatarUploadProps {
  user: {
    avatarCropped: string | undefined;
    initials: string;
    internalAvatarCropped: string | undefined;
  };
  onFileDrop: (files) => void;
  onFileDrag?: (files) => void;
  defaultComponent?: React.Component;
  wrongFormat?: boolean;
  disableClick?: boolean;
}

const WrongFormat = () => (
  <div className="wrongFormat colab-centered">
    <img src={wrongFormatImage} alt="Wrong Format" />
    <p className="message">Unsupported file type</p>
  </div>
);

export const SplitAvatarUpload = ({
  user,
  onFileDrop,
  defaultComponent,
  wrongFormat
}: AvatarUploadProps) => {
  return (
    <div className="SplitAvatarUpload">
      {user && (
        <div className="avatarsContainer">
          <div className="avatarWrapper left" title="Social Avatar">
            <Avatar
              className="avatar"
              url={user.avatarCropped}
              initials={user.initials}
              width={120}
            />
          </div>

          <div className="avatarWrapper right" title="Backend Avatar">
            <Dropzone
              onDrop={onFileDrop}
              multiple={false}
              acceptedFileTypes={ACCEPTED_IMAGE_FILE_TYPES}
              defaultComponent={
                defaultComponent || (
                  <React.Fragment>
                    {wrongFormat && <WrongFormat />}
                    {!wrongFormat && (
                      <Avatar
                        className="avatar"
                        url={user.internalAvatarCropped}
                        initials={user.initials}
                        key={user.internalAvatarCropped}
                        width={120}
                      />
                    )}
                  </React.Fragment>
                )
              }
            />
          </div>
        </div>
      )}
    </div>
  );
};

const AvatarUpload = ({
  user,
  onFileDrop,
  defaultComponent,
  wrongFormat,
  disableClick,
  onFileDrag
}: AvatarUploadProps) => (
  <div className="AvatarUpload">
    {user && (
      <div className="avatarsContainer">
        <div className="avatarWrapper">
          <UppercaseText className="colab-centered-h">Social</UppercaseText>
          <Avatar
            className="avatar"
            url={user.avatarCropped}
            initials={user.initials}
            width={256}
          />
        </div>

        <div className="avatarWrapper">
          <UppercaseText className="colab-centered-h">Backend</UppercaseText>
          <Dropzone
            onDrop={onFileDrop}
            onDrag={onFileDrag}
            multiple={false}
            acceptedFileTypes={ACCEPTED_IMAGE_FILE_TYPES}
            disableClick={disableClick}
            defaultComponent={
              defaultComponent || (
                <React.Fragment>
                  {wrongFormat && <WrongFormat />}
                  {!wrongFormat && (
                    <div className="changeAvatarContainer">
                      <Avatar
                        className="avatar"
                        url={user.internalAvatarCropped}
                        initials={user.initials}
                        key={user.internalAvatarCropped}
                        width={256}
                      />
                      <div className="changeText">Change Image</div>
                    </div>
                  )}
                </React.Fragment>
              )
            }
          />
        </div>
      </div>
    )}
  </div>
);

export default AvatarUpload;
